import { Group } from './types';
import { addGroupToLocalStorage, getGroups } from './storage';

const generateGroup = (rate: number): Group => {
  if (rate < 0 || rate > 1) {
    throw new Error(`Invalid rate: ${rate}. Expected in range 0-1.`);
  }
  return Math.random() < rate ? Group.experiment : Group.control;
};

export const getGroupForExperiment = (
  experimentId: string,
  experimentRate: number
): { group: Group; isNewEnrollment: boolean } => {
  const groups = getGroups();
  if (!groups) {
    return { group: Group.ineligible, isNewEnrollment: false };
  }

  if (experimentId in groups) {
    return { group: groups[experimentId], isNewEnrollment: false };
  }

  const newGroup = generateGroup(experimentRate);
  addGroupToLocalStorage(experimentId, newGroup);
  return { group: newGroup, isNewEnrollment: true };
};
